// extracted by mini-css-extract-plugin
export default {"item":"task-styles_item__pToaV","labelRol":"task-styles_labelRol__2raAE","labelArea":"task-styles_labelArea__2qhZX","titleItem":"task-styles_titleItem__okQjg"};